// libs
import React, { useState, useEffect, useCallback, memo } from 'react';

// components
import { IFrame } from './styles';
import ChunkFallback from 'shared/components/ChunkFallback';

// helpers
import { setUUID } from './helpers';

// defs
interface IFitCodeProps {
  onSubmit: (uuid: string) => void;
  onCancel: VoidFunction;
  fitcodeEndpoint: string;
}

const EVENT_IDENTIFIER = {
  CANCEL: 'fitcode-cancel',
  SUBMIT: 'fitcode-submit',
};

function FitCode({ onSubmit, onCancel, fitcodeEndpoint }: IFitCodeProps) {
  const [showLoader, setShowLoader] = useState(true);

  const hideLoader = () => setShowLoader(false);

  const onFitCodeSuccess = useCallback(
    (eventData: string) => {
      const uuid = eventData.split(':')[1].trim();
      setUUID(uuid);
      onSubmit(uuid);
    },
    [onSubmit]
  );

  const onFitCodeEvent = useCallback(
    (event: MessageEvent) => {
      const eventData = event.data;

      const submitRegExp = new RegExp(EVENT_IDENTIFIER.SUBMIT, 'i');

      if (eventData.toString().match(submitRegExp)) {
        onFitCodeSuccess(event.data);
        return;
      }

      if (event.data === EVENT_IDENTIFIER.CANCEL) {
        onCancel();
        return;
      }
    },
    [onCancel, onFitCodeSuccess]
  );

  useEffect(() => {
    window.addEventListener('message', onFitCodeEvent);

    return () => {
      window.removeEventListener('message', onFitCodeEvent);
    };
  }, [onFitCodeEvent]);

  return (
    <>
      {showLoader && <ChunkFallback />}
      <IFrame
        src={fitcodeEndpoint}
        title="Fit Advisor"
        onLoad={hideLoader}
        visibility={showLoader}
      />
    </>
  );
}

export default memo(FitCode);
